/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import {
  Divider,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";

type OrdersProps = {
  data: {
    received: number;
    delivered: number;
    canceled: {
      user: number;
      dealer: number;
      automatic: number;
    };
    declined: number;
  };
};

const Orders = ({
  data: { received, delivered, canceled, declined },
}: OrdersProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const media = useMediaQuery(theme.breakpoints.between("sm", "lg"));

  return (
    <Grid
      container
      columns={12}
      columnSpacing={1}
      display="flex"
      justifyContent="space-between"
      gap={1}
    >
      <Grid item>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          {t("ordersReceived")}
        </Typography>
        <Typography variant="h4" component="div">
          {received}
        </Typography>
      </Grid>
      <Divider orientation={media ? "horizontal" : "vertical"} flexItem />
      <Grid item>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          {t("ordersDelivered")}
        </Typography>
        <Typography variant="h4" component="div">
          {delivered}
        </Typography>
      </Grid>
      <Divider orientation={media ? "horizontal" : "vertical"} flexItem />
      <Grid item>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          {t("canceledOrders")}
        </Typography>
        <Typography
          variant="h4"
          component="div"
          color="#9847F5"
          display="flex"
          flexDirection="row"
        >
          {canceled.user + canceled.automatic + canceled.dealer}
          <div style={{ marginLeft: 15 }}>
            <Typography
              color="text.secondary"
              display="flex"
              flexDirection="row"
            >
              {t("user")}{" "}
              <Typography marginLeft={0.5} color="#9847F5">
                {canceled.user}
              </Typography>
            </Typography>
            <Typography
              color="text.secondary"
              display="flex"
              flexDirection="row"
            >
              {t("dealer")}{" "}
              <Typography marginLeft={0.5} color="#9847F5">
                {canceled.dealer}
              </Typography>
            </Typography>
            <Typography
              color="text.secondary"
              display="flex"
              flexDirection="row"
            >
              {t("automatic")}{" "}
              <Typography marginLeft={0.5} color="#9847F5">
                {canceled.automatic}
              </Typography>
            </Typography>
          </div>
        </Typography>
      </Grid>
      <Divider orientation={media ? "horizontal" : "vertical"} flexItem />
      <Grid item>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          {t("declinedRequests")}
        </Typography>
        <Typography variant="h4" component="div" color="#9847F5">
          {declined}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Orders;
